export default "__VITE_ASSET__B_yhi0WG__"